import React from "react";
import Reveal from "./Reveal";

const services = [
  {
    icon: "📄",
    title: "Thesis Writing",
    desc: "Expert chapter-by-chapter thesis writing with structured flow, proper citations, and methodology alignment tailored to your university guidelines.",
    flag: { label: "Most Popular", cls: "flag-popular" },
  },
  {
    icon: "📊",
    title: "Data Analysis",
    desc: "Advanced statistical analysis using SPSS, R, Python, or MATLAB — with comprehensive interpretation and results presentation.",
  },
  {
    icon: "📚",
    title: "Literature Review",
    desc: "In-depth literature surveys, gap identification, and thematic analysis sourced from peer-reviewed journals and academic databases.",
  },
  {
    icon: "🗞️",
    title: "Publication Support",
    desc: "End-to-end support for getting your research published in Scopus, SCI, and UGC-listed journals — including manuscript prep and submission.",
    flag: { label: "High Demand", cls: "flag-demand" },
  },
  {
    icon: "✏️",
    title: "Editing & Proofreading",
    desc: "Professional academic editing for grammar, clarity, coherence, and formatting consistency — making your work submission-ready.",
  },
  {
    icon: "🧪",
    title: "Research Proposal",
    desc: "Compelling research proposals with strong problem statements, objectives, and methodology — designed to get approval first time.",
  },
  {
    icon: "📈",
    title: "Bibliometric Analysis",
    desc: "Comprehensive bibliometric studies using VOSviewer, R, and Python — mapping research trends, citation networks, and knowledge gaps.",
  },
  {
    icon: "📝",
    title: "Synopsis",
    desc: "Crisp, well-structured synopses that capture your research essence — crafted to meet university format requirements.",
  },
  {
    icon: "📰",
    title: "Research Paper",
    desc: "Publication-ready research papers with rigorous literature grounding, clear methodology, and impactful discussion sections.",
  },
  {
    icon: "🔬",
    title: "Review Paper",
    desc: "Systematic and narrative review papers synthesizing hundreds of sources into a coherent, publishable manuscript.",
  },
  {
    icon: "🔍",
    title: "Plagiarism Check & Removal",
    desc: "Turnitin-based plagiarism detection and expert paraphrasing to bring your similarity index within university thresholds.",
  },
  {
    icon: "💎",
    title: "Full PhD Support Package",
    desc: "Our all-in-one package covering topic selection, proposal, literature review, data analysis, thesis writing, editing, and publication.",
    flag: { label: "Best Value", cls: "flag-value" },
  },
];

export default function Services() {
  return (
    <section id="services">
      <div className="wrap">
        <Reveal className="section-head">
          <div className="eyebrow">Our Services</div>
          <h2>Complete PhD support package</h2>
          <p>
            From your first research question to final publication — we
            cover every stage of your doctoral journey.
          </p>
        </Reveal>

        <div className="services-grid">
          {services.map((s) => (
            <Reveal as="div" className="service-card" key={s.title}>
              {s.flag && (
                <span className={`flag ${s.flag.cls}`}>{s.flag.label}</span>
              )}
              <div className="ic">{s.icon}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
